import { Icon, mergeStyleSets } from '@fluentui/react';
import { useState } from 'react';

import { useAppSelector } from '../../App/store';
import { theme } from '../../utils/theme';
import openModal from './openModal';
import { actions } from './slice';

export type CalendarItemInfo = {
  dateStart: Date;
  dateEnd: Date;
  formId: string;
  data: any;
};

export type CalendarItemProps = {
  itemInfo: CalendarItemInfo;
  date: Date;
};

export default (props: CalendarItemProps) => {
  const { itemInfo, date } = props;
  const bodyStyles = [styles.item];

  const [isHoveringThis, setIsHoveringThis] = useState(false);
  const isHovering = useAppSelector(
    (state) => state.calendar.hoveringFormId === itemInfo.formId
  );
  let showDetails = false;
  let backgroundColor: string;

  if (isHoveringThis) {
    showDetails = true;
  }

  if (isHovering) {
    bodyStyles.push(styles["item-hover"]);
  }

  if (itemInfo.dateStart.getTime() === itemInfo.dateEnd.getTime()) {
    // nothing
    showDetails = true;
  } else if (itemInfo.dateStart.getTime() === date.getTime()) {
    bodyStyles.push(styles["item-start"]);
    showDetails = true;
  } else if (itemInfo.dateEnd.getTime() === date.getTime()) {
    bodyStyles.push(styles["item-end"]);
  } else {
    bodyStyles.push(styles["item-center"]);
  }

  if (isHovering && !isHoveringThis) {
    showDetails = false;
  }

  switch (itemInfo.data.shipment.status) {
    case "urgent":
      backgroundColor = theme.palette.redDark;
      break;

    case "date-range":
    case "date":
      backgroundColor = theme.palette.themePrimary;
      break;

    default:
      backgroundColor = theme.palette.neutralDark;
      break;
  }

  return (
    <div
      className={bodyStyles.join(" ")}
      style={{ backgroundColor }}
      onMouseEnter={() => {
        actions.setHoveringFormId(itemInfo.formId);
        setIsHoveringThis(true);
      }}
      onMouseLeave={() => {
        actions.unsetHoveringFormId(itemInfo.formId);
        setIsHoveringThis(false);
      }}
      onClick={async () => {
        openModal(itemInfo.formId);
      }}
    >
      <div className={styles.container}>
        {showDetails ? (
          <>
            {itemInfo.data.displayName}&nbsp;
            <Icon iconName="Zoom" className="view-icon" />
          </>
        ) : (
          <>&nbsp;</>
        )}
      </div>
    </div>
  );
};

const styles = mergeStyleSets({
  container: {
    padding: "4px",
  },
  item: {
    backgroundColor: theme.palette.themePrimary,
    boxShadow: theme.effects.elevation4,
    width: "95%",
    minHeight: "16px",
    borderRadius: "4px",
    color: "white",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& .view-icon": {
      display: "none",
    },
  },
  "item-start": {
    borderRadius: "4px 0 0 4px",
    width: "calc(100% + 6px)",
    zIndex: 10,
  },
  "item-center": {
    borderRadius: "0",
    width: "calc(100% + 14px)",
    marginLeft: "-7px",
    zIndex: 10,
    background: `repeating-linear-gradient(
      45deg,
      ${theme.palette.themePrimary},
      ${theme.palette.themePrimary} 1.125vw,
      ${theme.palette.themeSecondary} 1.125vw,
      ${theme.palette.themeSecondary} 2.25vw
    )`,
    opacity: 0.9,
  },
  "item-end": {
    borderRadius: "0 4px 4px 0",
    width: "calc(100% + 6px)",
    marginLeft: "-6px",
    zIndex: 10,
    background: `repeating-linear-gradient(
      45deg,
      ${theme.palette.themePrimary},
      ${theme.palette.themePrimary} 1.125vw,
      ${theme.palette.themeSecondary} 1.125vw,
      ${theme.palette.themeSecondary} 2.25vw
    )`,
    opacity: 0.9,
  },
  "item-hover": {
    backgroundColor: `${theme.palette.neutralSecondary} !important`,
    opacity: 1,
    background: "none",
    boxShadow: "none",
    cursor: "pointer",
    "& .view-icon": {
      display: "unset",
    },
  },
});
